<script lang="ts" setup>
import TripMonitorSearchForm from "@/views/trips/monitor/components/TripMonitorSearchForm.vue";
import TripsList from "@/views/trips/monitor/components/TripsList.vue";
import { ref } from "vue";
import type { TripMonitorSearchParams } from "@/api/trips/dto/trip-monitor";
import ContainerLayout from "@/components/layout/ContainerLayout.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const searchParams = ref<TripMonitorSearchParams | null>(null);
const isFilterVisible = ref<boolean>(true);
const searchFormHeight = ref<number>(0);

function search(params: TripMonitorSearchParams) {
  searchParams.value = { ...params };
}
</script>

<template>
  <container-layout :header="t('trip.trip-monitor')">
    <transition name="slide-filters">
      <trip-monitor-search-form
        v-show="isFilterVisible"
        v-model:height="searchFormHeight"
        :visible="isFilterVisible"
        @search="search"
      />
    </transition>

    <trips-list :search-params="searchParams" />
  </container-layout>
</template>

<style lang="scss" scoped>
.slide-filters-enter-active,
.slide-filters-leave-active {
  transition:
    transform 0.5s ease,
    opacity 0.5s ease;
}

.slide-filters-enter-from,
.slide-filters-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
